
import React from 'react';
import { motion } from 'framer-motion';

interface TechBackgroundProps {
  children: React.ReactNode;
}

const TechBackground: React.FC<TechBackgroundProps> = ({ children }) => {
  return (
    <div className="relative overflow-hidden">
      {/* Background with tech-inspired grid and glow effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#001233] to-[#031A30]"></div>
      
      {/* Animated tech elements */}
      <motion.div 
        className="absolute top-10 left-10 w-20 h-20 border border-blue-400/20 rounded-md"
        animate={{ 
          rotate: 360,
          opacity: [0.5, 0.8, 0.5]
        }}
        transition={{ 
          repeat: Infinity,
          duration: 20,
          ease: "linear"
        }}
      />
      
      <motion.div 
        className="absolute top-1/4 right-1/4 w-40 h-40 border-2 border-purple-400/20 rounded-full"
        animate={{ 
          scale: [1, 1.1, 1],
          opacity: [0.3, 0.5, 0.3]
        }}
        transition={{ 
          repeat: Infinity,
          duration: 15, 
          ease: "easeInOut"
        }}
      />
      
      <motion.div 
        className="absolute bottom-20 right-10 w-32 h-32 border border-cyan-400/20 rounded-md rotate-45"
        animate={{ 
          rotate: [-45, 0, -45],
          opacity: [0.2, 0.4, 0.2]
        }}
        transition={{ 
          repeat: Infinity,
          duration: 10,
          ease: "easeInOut"
        }}
      />
      
      {/* Binary code decoration */}
      <div className="absolute top-0 left-0 text-white/5 text-xs select-none font-mono">
        {Array.from({ length: 15 }).map((_, i) => (
          <div key={i}>
            {Array.from({ length: 40 }).map((_, j) => (
              <span key={j}>{Math.random() > 0.5 ? '1' : '0'}</span>
            ))}
          </div>
        ))}
      </div>
      
      <div className="absolute bottom-0 right-0 text-white/5 text-xs select-none font-mono">
        {Array.from({ length: 15 }).map((_, i) => (
          <div key={i}>
            {Array.from({ length: 40 }).map((_, j) => (
              <span key={j}>{Math.random() > 0.5 ? '1' : '0'}</span>
            ))}
          </div>
        ))}
      </div>
      
      {/* Content */}
      <div className="relative z-10 p-4 md:p-8">
        {children}
      </div>
    </div>
  );
};

export default TechBackground;
